/**
 * The crossed `_min`/`_max` finding that CPUParticles2D, CPUParticles3D and ParticleProcessMaterial
 * share. `rulePrefix` is the type slug, so each class keeps its own `<prefix>-param-min-above-max` rule.
 */
import { armDiagnostic } from './ruleArms.js';
import { crossedParamRanges } from '../godot/scene/particleParamRange.js';
import { formatReal } from '../godot/math/real.js';
/** The arm under `rulePrefix`, grounded at `setterAt`, the class's own setter that alters the value. */
export function paramMinAboveMaxArm(rulePrefix, setterAt) {
    return {
        severity: 'warning',
        ruleName: `${rulePrefix}-param-min-above-max`,
        grounding: { kind: 'engine', at: setterAt },
    };
}
/** One finding per crossed pair of `stems`, on the key the file lists first, which loads changed. */
export function paramMinAboveMaxFindings(properties, stems) {
    return crossedParamRanges(properties, stems).map(({ minKey, maxKey, min, max, movedKey }) => ({
        property: movedKey,
        message: `'${minKey}' ${formatReal(min)} is above '${maxKey}' ${formatReal(max)}. Godot applies them in the order the file lists them, so '${movedKey}' loads as ${formatReal(movedKey === minKey ? max : min)}.`,
    }));
}
/** One diagnostic on `node` per crossed pair of `stems`. */
export function paramMinAboveMaxDiagnostics(node, properties, stems, arm) {
    return paramMinAboveMaxFindings(properties, stems).map(({ message }) => armDiagnostic(arm, node, message));
}
//# sourceMappingURL=paramMinAboveMax.js.map